module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/High Pixel Autofocus Camera.8847d1ac.png";